export default __webpack_public_path__ + "static/char-thumb-62-abb51a441059e059bcce2b7c812334c4.png";